<template>
  <div class="h-screen flex w-full bg-img relative" id="page-login">
    <div class="vx-col sm:w-1/3 m-auto self-center login-page full-page z-10">
      <div class="vx-row m-auto">
        <div class="vx-col w-full">
          <h1 align="center" class="my-4">{{ $t("labels.iqcrm") }}</h1>

          <div class="vx-row justify-center flex">
            <div class="vx-col w-full">
              <vx-card class="login-card">
                <div class="vx-card__title mb-5">
                  <h2 align="center">Explore SID</h2>
                  <p class="pt-4 text-primary" align="center">
                    Discover our platform and connect with us to get started.
                  </p>
                </div>

                <div class="my-5 login-btn flex justify-center gap-4">
                  <vs-button @click="showPopForm = true" class="vs-button vs-button-primary vs-button-filled px-6">
                    New User
                  </vs-button>
                  <vs-button @click="redirectToLogin" class="vs-button vs-button-success vs-button-filled px-6">
                    Existing User
                  </vs-button>
                </div>
              </vx-card>

              <div class="login-footer md:flex my-6" align="center">
                <a class="md:pr-6">{{ $t("labels.privacy") }}</a>
                <a class="md:pl-6">{{ $t("labels.terms") }}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Contact Form -->
    <div v-if="showPopForm" class="modal-overlay">
      <div class="modal-box" id="user-contact-form"> <!-- ADDED ID HERE -->
        <div class="modal-header">
          <h3>Let’s Connect & Grow Together 🚀</h3>
          <span class="modal-close" @click="showPopForm = false">×</span>
        </div>

        <div class="modal-body">
          <div class="form-group">
            <label>Name</label>
            <vs-input v-model="contactForm.name" type="text" class="w-full" :danger="!contactForm.name && triedSubmit"
              danger-text="Name is required" />
          </div>

          <div class="form-group">
            <label>Email</label>
            <vs-input v-model="contactForm.email" type="text" class="w-full" :danger="!contactForm.email && triedSubmit"
              danger-text="Email is required" />
          </div>

          <div class="form-group">
            <label>Phone Number</label>
            <vue-tel-input v-model="contactForm.fullPhone" @input="onPhoneInput" :placeholder="''" default-country="GB"
              class="w-full" :danger="!contactForm.fullPhone && triedSubmit" danger-text="Phone number is required" />
          </div>

          <div class="form-group">
            <label>Message</label>
            <vs-textarea v-model="contactForm.message" class="w-full" :danger="!contactForm.message && triedSubmit"
              danger-text="Message is required" />
          </div>
        </div>

        <div class="modal-footer mt-4">
          <vs-button color="primary" @click="submitContactForm">Submit</vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showPopForm: false,
      triedSubmit: false,
      contactForm: {
        name: '',
        email: '',
        countryCode: '+44',
        phone: '',
        message: '',
        fullPhone: ''
      },
    };
  },
  methods: {
    redirectToLogin() {
      this.$router.push('/auth/login');
    },
    async submitContactForm() {
      this.triedSubmit = true;
      const { name, email, fullPhone, message } = this.contactForm;

      if (!name || !email || !fullPhone || !message) {
        return;
      }

      try {
        const responseData = await this.getHTTPPostResponse(
          "/contact_us",
          {
            name: name.trim(),
            email: email.trim(),
            phone: fullPhone.trim(),
            message: message.trim(),
          },
          '#user-contact-form', // <- use this as loader target
          false // <- success_message
        );

        if (responseData && responseData.status === '200') {
          this.$vs.notify({
            title: 'Submitted',
            text: 'Thank you! We’ll get in touch shortly.',
            color: 'success',
            position: 'top-right',
          });

          this.showPopForm = false;
          this.contactForm = {
            name: '',
            email: '',
            countryCode: '+44',
            phone: '',
            message: '',
            fullPhone: ''
          };
          this.triedSubmit = false;
        } else {
          this.$vs.notify({
            title: 'Error',
            text: responseData.message || 'Submission failed.',
            color: 'danger',
            position: 'top-right',
          });
        }

      } catch (error) {
        this.$vs.loading.close('#user-contact-form');
        this.$vs.notify({
          title: 'Error',
          text: 'Something went wrong. Please try again later.',
          color: 'danger',
          position: 'top-right',
        });
        console.error(error);
      }
    },
    onPhoneInput(value) {
      // optional formatting
    }
  },
};
</script>

<style scoped>
.login-footer {
  justify-content: center;
}

.login-footer a {
  color: #fff;
  font-weight: 600;
  font-size: 12px;
  cursor: pointer;
}

.login-footer a:hover {
  text-decoration: underline;
}

.login-btn button {
  background: rgba(var(--vs-primary), 1) !important;
}

.vs-button-primary.vs-button-filled:hover {
  box-shadow: 0 8px 25px -8px rgba(var(--vs-primary), 1);
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 50;
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-box {
  background: #fff;
  padding: 2rem;
  border-radius: 12px;
  width: 500px;
  max-width: 90%;
  box-shadow: 0 2px 30px rgba(0, 0, 0, 0.2);
  position: relative;
  font-size: 1rem;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: bold;
  font-size: 1.2rem;
  margin-bottom: 1rem;
}

.modal-close {
  font-size: 1.5rem;
  cursor: pointer;
  color: #999;
}

.modal-body {
  display: flex;
  flex-direction: column;
}

.form-group {
  margin-bottom: 1rem;
  display: flex;
  flex-direction: column;
}

.form-group label {
  font-weight: 600;
  margin-bottom: 0.25rem;
  font-size: 1rem;
}
</style>
